<template> 
    <div id="dynamic-detail" class="flex-column">
        <Title :iconBack="true"/>
        <div class="flex-column-1">
        	<img :src="data.titleImageUrl" class="img-fluid" style="">
	        <div class="p-1 d-flex justify-content-between">
	            <span class="title">{{data.title}}</span>
	        </div>
	        <div class="content-box">
	        	<p v-html="data.content"></p>
	        </div>
        </div>
        <NavbarFooter/>    
    </div>
</template>
<script>
import {GET_APPLET_MESSAGE_DETAIL} from '@/assets/configs/api/yuanqu'	
export default {
	data () {
		return {
			share : {
				shareURL : "www.baidu.com",
				shareTitle : "百度网盘",
				shareContent : "bt下载",
				localLink : location.href
			},
			id:null,
			data:{}
		}
	},
	methods : {
		getDetail () {
			this.$get(GET_APPLET_MESSAGE_DETAIL,
				{
					id: this.id
				},
				data => {
					this.data = data
				},
		        error => {
		        	
		        }
	      	)
		}
	},
    mounted() {
        this.id = JSON.parse(this.$route.query.id)
        this.getDetail()
    },
    computed: {
    	
    }
}
</script>

<style lang="scss">
    .img-fluid{
        width: 100%;
    }
    #dynamic-detail{
		.p-1{
    		font-size:16px;
    		.title{
    			font-weight: 600;
    		}
    	}
    	.content-box{
    		padding:0 0.4rem;
    		text-indent: 32px;
    		overflow-x: hidden;
    		img{
    			max-width: 100%;
    			margin:0;
    		}
    		p{
    			font-size:14px;
    			padding:0;
    			margin:0;
    			img{
	    			max-width: 100%;
	    			margin:0;
	    		}
    		}
    	}
    }
    
</style>
    